import { defaultListener } from "../helper"
import { isEmpty } from "lodash"
import { parseRef } from "../../firebase"

export default {
  state: {
    templates: {}
  },
  getters: {
    getTemplates: (state) => Object.values(state.templates) || [],
    getTemplatesByType: (state, getters) => (type) => getters.getTemplates.filter(t => t.type === type),
    getTemplate: (state) => (id) => state.templates[id] || {}
  },
  actions: {
    async ensureTemplate({ getters, state, commit }, data) {
      /**
       * @todo Also search tenant templates; just searches root templates for now
       */
      const { id } = data
      let template = state.templates[ id ] || {}

      const sessionTenant = getters.getSessionTenant

      if (isEmpty(template)) {
        template = await this.$db
          .collection('templates')
          .doc(id)
          .get()
          .then(ref => {
            const found = parseRef(ref)

            if (found) commit('ADD_TEMPLATE', found)

            return found
          })
          .catch(e => console.log(e))
      }

      return template
    },
    async initTemplates({ commit, getters }, data) {
      const { type } = data || {}
      const sessionTenant = getters.getSessionTenant

      console.log(type, sessionTenant)
      if (type) {
        // First fetch the system templates
        this.$firebase.firestore()
          .collection('templates')
          .where('type', '==', type)
          .onSnapshot(defaultListener.bind(this, commit, 'ADD_TEMPLATE', 'REMOVE_TEMPLATE')
            , e => console.log(e))

        // Second, fetch the templates defined by the tenant (if any)
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('templates')
          .where('type', '==', type)
          .onSnapshot(defaultListener.bind(this, commit, 'ADD_TEMPLATE', 'REMOVE_TEMPLATE')
            , e => console.log(e))
      }
    }
  },
  mutations: {
    ADD_TEMPLATE(state, template) {
      const { id } = template

      if (id) {
        const newState = { ...state.templates }
        newState[ id ] = template
        state.templates = newState
      }
    },
    REMOVE_TEMPLATE(state, id) {
      if (state.templates[ id ]) {
        const newState = { ...state.templates }
        delete newState[ id ]
        state.templates = newState
      }
    }
  }
}
